/**
 * Provides translations for different languages.
 */
class Locale
{


    constructor()
    {
        this.app = PIXI.app;
        this.translations = PIXI.loader.resources.locale.data;
    }


    /**
     * Get the translation for a string with the specified identifier.
     * @param stringId
     * @returns {String}
     */
    getString(stringId)
    {
        let translation = this.translations[stringId];

        if (!translation)
        {
            translation = "?";
        }

        return translation;
    }


}


export default Locale;